<cac-dialog-layout
  [title]="data.vendor ? 'Edit Vendor' : 'Create new Vendor'"
  subtitle="Enter the required data and save"
  [form]="form"
  (onSubmit)="onSubmit($event)"
>
  <cac-tabs>
    <cac-tab label="Vendor Information">
      <div class="flex gap-6 mt-3">
        <div class="grid grid-cols-2 gap-x-6 gap-y-2 w-full">
          <cac-field [control]="form.controls.vendorName" label="Vendor Name"></cac-field>
          <cac-field [control]="form.controls.email" label="Email"></cac-field>
        </div>
      </div>
      <div class="grid grid-cols-6 gap-x-6 gap-y-2 mt-5">
        <cac-field
          label="Password"
          [control]="form.controls.password"
          class="col-span-2"
          inputType="password-eye"
          autoComplete="new-password"
        ></cac-field>
        <cac-field
          label="Confirm Password"
          [control]="form.controls.passwordConfirm"
          class="col-span-2"
          inputType="password-eye"
          autoComplete="new-password"
        ></cac-field>
        <cac-field
          [control]="form.controls.status"
          label="Status"
          controlType="select"
          [searchable]="false"
          [clearable]="false"
          [items]="StatusValues"
          class="col-span-2"
        ></cac-field>
      </div>
    </cac-tab>
    <cac-tab label="Vendor Orders" *ngIf="data.vendor">
      <cac-table [options]="ordersTable"></cac-table>
    </cac-tab>
    <cac-tab label="Vendor Products" *ngIf="data.vendor">
      <cac-table [options]="productsTable"></cac-table>
    </cac-tab>
  </cac-tabs>
  <div class="flex gap-2 me-auto" slot="bottom">
    @if (data.vendor) {
      <cac-button *ngIf="!isRestrictedAdmin" (onClick)="onDelete($event)" theme="error">Delete Vendor</cac-button>
    }
  </div>
</cac-dialog-layout>
